import React, { Component } from "react";
import styled from "styled-components";

export default class PrimaryHeading extends Component {
  render() {
    const Heading = styled.h1`
      font-size: 6vw;
      font-family: "Proxima Nova Condensced", sans-serif;
      font-weight: normal;
      position: relative;
      line-height: 1;
      display: inline-block;
      vertical-align: middle;
      margin-left: -1vw;
      margin-bottom: 1vw;
      color: ${props => props.theme.colors[color]};

      @media screen and (min-width: 1920px) {
        font-size: 110px;
      }

      @media (max-width: 992px) {
        font-size: 6.8vw;
      }

      @media (max-width: 767px) {
        font-size: 8vw;
      }
    `;

    const Subheading = styled.h2`
      font-size: 39px;
      font-family: "Proxima Nova Condensced", sans-serif;
      margin-left: -1vw;
      color: ${props => props.theme.colors[color]};

      @media (max-width: 992px) {
        font-size: 3.2vw;
      }
      @media (max-width: 767px) {
        font-size: 4.5vw;
      }
    `;

    const Img = styled.img`
      max-width: 1.8em;
      margin-top: -0.3em;
    `;
    const { heading, subheading, img, color } = this.props;
    return (
      <div className={this.props.className}>
        <Heading>
          <Img src={img} />
          {heading}
        </Heading>
        <Subheading>{subheading}</Subheading>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/PrimaryHeading/index.js